import { ToolWrapper } from './ToolTipStyle';
import { BottomPolygon, RightPolygon, TopPolygon } from '../../Theme/Icons';

import { useState } from 'react';

export const ToolTip = ({ content, position = 'Right', children, hide = false, minWidth, maxWidth, isOpen, right, zIndex = '' }) => {
  const [visible, setVisible] = useState(false);

  const showTooltip = () => setVisible(true);
  const hideTooltip = () => setVisible(false);

  return hide || !content ? children :
    <ToolWrapper minWidth={minWidth} maxWidth={maxWidth} right={right} $zIndex={zIndex}>
      <div className="tooltip-container" onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
        {children}
        {(visible || isOpen) && (
          <div className={`toolTip toolTip-${position}`}>
            {position == 'Bottom' && <BottomPolygon className={'ToolArrow'} />}
            {position == 'Top' && <TopPolygon className={'ToolArrow'} />}
            {position == 'Right' && <RightPolygon className={'ToolArrow'} />}
            {content}
          </div>
        )}
      </div>
    </ToolWrapper>
};